// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 获取文件直传签名 获取文件直传签名 POST /api/admin/upload/signature */
export async function uploadFileSignatureApiAdminUploadSignaturePost(
  body: API.FileUploadRequest,
  options?: { [key: string]: any }
) {
  return request<API.ApiResponseFileUploadResponse_>(
    "/api/admin/upload/signature",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
